import {createSlice} from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: "userReducer",
    initialState: {
        sessionData:{},
        profileData:{},
        registerData: {},
        forgetData:{},
        currentRole: "Student",
        contactData:{}
    },
    reducers: {
        setSessionData: (state, action) => {
            state.sessionData = action.payload;
        },
        setName: (state, action) => {
            state.sessionData.name = action.payload;
        },
        setProfileData: (state, action) => {
            state.profileData = action.payload;
        },
        resetProfileData: (state, action) => {
            state.profileData = {}
        },
        resetSessionData(state, action) {
            state.sessionData = {}
        },
        // Register
        setRegisterData(state, action) {
            state.registerData = action.payload
        },
        resetRegisterData(state, action) {
            state.registerData = {}
        },
        // Forget Password
        setForgetData(state, action) {
            state.forgetData = action.payload
        },
        resetForgetData(state, action) {
            state.forgetData = {}
        },
        // Set Role 
        setRole(state, action) {
            state.currentRole = action.payload;
        },
        setContactData(state, action) {
            state.contactData = action.payload;
        },
    }
});

export const userAction = userSlice.actions;

export default userSlice;